const ssoLoginUrl = '/twigscience/login';
const ssoLogoutCallback = '/logout-callback';
const ssoLoginCallback = '/login-callback';
const ltiLoginUrl = '/login-lti';

export { ssoLogoutCallback, ssoLoginCallback, ltiLoginUrl };
export default ssoLoginUrl;
